<template>
  <div class="form-group" align="left">
    <div class="form-row">
      <div class="form-input" :class="classes">
        <vue-input-mask
          :placeholder="$t('paymentdetails.cards.placeholderCardnumber')"
          class="form-control cc-number"
          :class="ccClass"
          v-model="cardNumber"
          @input="$emit('input', cardNumber)"
          :options="{
            creditCard: true,
            onCreditCardTypeChanged: onCreditCardTypeChanged,
          }"
          id="cardNumber"
          name="cardNumber"
          data-test="card-number-input"
          autocomplete="cc-number"
          x-autocompletetype="cc-number"
          pattern="\d*"
          type="text"
          ref="cardInput"
        ></vue-input-mask>
        <label for="cardNumber" data-test="card-number-label">{{
          $t("paymentdetails.cards.labelCardnumber")
        }}</label>
        <div
          v-if="messages[0]"
          class="form-input-validation"
          data-test="form-input-validation"
        >
          <div class="form-input-notes-left" :title="messages[0]">
            {{ messages[0] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueInputMask from "vue2-input-mask";

export default {
  name: "cardNumber",
  props: ["value", "messages", "flags"],
  components: {
    vueInputMask,
  },
  data() {
    return {
      cardNumber: "",
      ccClass: "unknown",
    };
  },
  watch: {
    cardNumber: function () {
      setTimeout(() => {
        const card = {
          cardNumber: this.cardNumber,
          cardType: this.ccClass,
        };
        this.$emit("updatecc", card);
      }, 0);
    },
  },
  computed: {
    classes() {
      if (this.flags.validated && !this.flags.valid) {
        return "error";
      }
      if (this.flags.validated && this.flags.valid) {
        return "success";
      }
      return "";
    },
  },
  methods: {
    onCreditCardTypeChanged(type) {
      let cardType = type === "unknown" ? "" : type;
      this.ccClass = cardType;
    },
  },
};
</script>
